import { combineReducers } from "@reduxjs/toolkit";
import initOptionsSlice from "./initoptions";
import { facilityApi } from "./facilityapi";

export const rootReducer = combineReducers({
    initOptions: initOptionsSlice,
    [facilityApi.reducerPath]: facilityApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
